"use strict";
module.exports = entity => {
    const result = {
        ...entity,
    };
    return result;
};
